import { motion } from 'framer-motion';
import { ArrowLeft, Mail, Shield, Users } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const RegisterBlocked = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { role, email = 'admin@pesacore.fr' } = location.state || {};

  const isAdmin = role === 'admin' || role === 'superviseur';

  const title = isAdmin 
    ? "Accès Superviseur temporairement fermé" 
    : "Accès temporairement fermé";

  const description = isAdmin 
    ? "Nous contrôlons l'arrivée des premiers superviseurs sur la plateforme."
    : "Nous contrôlons actuellement l'arrivée des premiers utilisateurs.";

  return (
    <div className="min-h-screen bg-[#020617] text-slate-200 relative overflow-hidden font-sans">
      {/* Background identique à la homepage */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-cyan-950/10 via-[#020617] via-50% to-amber-950/10" />
        <div className="absolute inset-0 bg-[linear-gradient(rgba(18,16,16,0)_50%,rgba(0,0,0,0.05)_50%)] bg-[length:100%_4px] opacity-20" />
      </div>

      <div className="relative z-10 min-h-screen flex items-center justify-center px-6 py-20">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-lg w-full"
        >
          {/* Card principale */}
          <div className="relative p-[1px] rounded-3xl bg-gradient-to-br from-white/10 via-white/5 to-transparent">
            <div className="bg-slate-950/90 backdrop-blur-3xl rounded-[23px] p-10 border border-white/5 shadow-2xl">
              
              {/* Icône */}
              <div className="flex justify-center mb-8">
                <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-amber-500/10 to-cyan-500/10 flex items-center justify-center border border-amber-500/20">
                  {isAdmin ? (
                    <Shield size={48} className="text-amber-400" />
                  ) : (
                    <Users size={48} className="text-cyan-400" />
                  )}
                </div>
              </div>

              <h1 className="text-4xl md:text-5xl font-light tracking-tighter text-center text-white mb-6">
                {title}
              </h1>

              <p className="text-slate-400 text-center leading-relaxed text-lg mb-10">
                {description}<br />
                Pour obtenir un accès, merci de contacter l’administration.
              </p>

              {/* Bouton email */}
              <a
                href={`mailto:${email}?subject=Demande d'accès ${isAdmin ? 'Superviseur' : 'Learner'}`}
                className="group relative w-full flex items-center justify-center gap-3 py-5 px-8 bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 text-slate-950 font-bold uppercase tracking-[0.2em] text-sm rounded-2xl overflow-hidden transition-all hover:scale-[1.02] active:scale-[0.98] mb-8"
              >
                <Mail size={20} />
                <span>Contacter admin@pesacore.fr</span>
                <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 via-cyan-300 to-cyan-400 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
              </a>

              {/* Retour */}
              <button
                onClick={() => navigate('/home-page')}
                className="flex items-center gap-2 mx-auto text-slate-400 hover:text-white transition-colors font-mono text-sm group"
              >
                <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                Page d'accueil
              </button>
            </div>
          </div>

          {/* Petit texte en bas */}
          <div className="mt-10 text-center">
            <p className="text-[10px] font-mono tracking-widest text-slate-500">
              PHASE DE CONTRÔLE DES PRIMO-INSCRITS
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default RegisterBlocked;